// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
var PropertyWizardRelayShowingsShowing_draft_graphql = require("../../../__generated__/PropertyWizardRelayShowingsShowing_draft_graphql.bs.js");
var PropertyWizardRelayShowingsShowing_showing_graphql = require("../../../__generated__/PropertyWizardRelayShowingsShowing_showing_graphql.bs.js");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value;
}

var $$Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function makeOption(value) {
  var tmp;
  switch (value) {
    case "AGENTS_ONLY" :
        tmp = "Agents only";
        break;
    case "BUYERS_WELCOME" :
        tmp = "Buyers welcome";
        break;
    case "TAN_ONLY" :
        tmp = "TAN only";
        break;
    
  }
  return {
          value: value,
          label: tmp
        };
}

var options = [
    "TAN_ONLY",
    "AGENTS_ONLY",
    "BUYERS_WELCOME"
  ].map(makeOption);

function PropertyWizardRelay__Showings__Showing$ShowingTypeInputField(props) {
  var onChange = props.onChange;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Form__Label.make, {
                      labelText: "Showing type"
                    }),
                JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                      getOptionLabel: getOptionLabel,
                      getOptionValue: getOptionValue,
                      isClearable: true,
                      onChange: (function (value) {
                          onChange(Core__Option.map(value, (function (param) {
                                      return param.value;
                                    })));
                        }),
                      options: options,
                      placeholder: "Showing type",
                      value: Core__Option.map(props.value, makeOption)
                    })
              ]
            });
}

var ShowingTypeInputField = {
  $$Option: $$Option,
  makeOption: makeOption,
  options: options,
  make: PropertyWizardRelay__Showings__Showing$ShowingTypeInputField
};

var convertFragment = PropertyWizardRelayShowingsShowing_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment_showingTypeV5_decode = PropertyWizardRelayShowingsShowing_showing_graphql.Utils.showingTypeV5_decode;

var ShowingFragment_showingTypeV5_fromString = PropertyWizardRelayShowingsShowing_showing_graphql.Utils.showingTypeV5_fromString;

var ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayShowingsShowing_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Showings__Showing(props) {
  var showingNum = props.showingNum;
  var showing = use(props.showing);
  var draft = use$1(props.draft);
  var updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  var typProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Showing",
        showingNum: showingNum,
        updater: (function (dp, value) {
            return {
                    date: dp.date,
                    endTime: dp.endTime,
                    id: dp.id,
                    key: dp.key,
                    notes: dp.notes,
                    startTime: dp.startTime,
                    type_: value
                  };
          })
      }, true, showing.type_, PropertyWizardFormRelay__Validators__Showings.Showing.Type.useIsValid(showing.fragmentRefs));
  var startTimeProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Showing",
        showingNum: showingNum,
        updater: (function (dp, value) {
            return {
                    date: dp.date,
                    endTime: dp.endTime,
                    id: dp.id,
                    key: dp.key,
                    notes: dp.notes,
                    startTime: value,
                    type_: dp.type_
                  };
          })
      }, true, showing.startTime, PropertyWizardFormRelay__Validators__Showings.Showing.StartTime.useIsValid(showing.fragmentRefs));
  var endTimeProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Showing",
        showingNum: showingNum,
        updater: (function (dp, value) {
            return {
                    date: dp.date,
                    endTime: value,
                    id: dp.id,
                    key: dp.key,
                    notes: dp.notes,
                    startTime: dp.startTime,
                    type_: dp.type_
                  };
          })
      }, true, showing.endTime, PropertyWizardFormRelay__Validators__Showings.Showing.EndTime.useIsValid(showing.fragmentRefs));
  var dateProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Showing",
        showingNum: showingNum,
        updater: (function (dp, value) {
            return {
                    date: value,
                    endTime: dp.endTime,
                    id: dp.id,
                    key: dp.key,
                    notes: dp.notes,
                    startTime: dp.startTime,
                    type_: dp.type_
                  };
          })
      }, true, showing.date, PropertyWizardFormRelay__Validators__Showings.Showing.$$Date.useIsValid(showing.fragmentRefs, draft.fragmentRefs));
  var notesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Showing",
        showingNum: showingNum,
        updater: (function (dp, value) {
            return {
                    date: dp.date,
                    endTime: dp.endTime,
                    id: dp.id,
                    key: dp.key,
                    notes: value,
                    startTime: dp.startTime,
                    type_: dp.type_
                  };
          })
      }, true, showing.notes, PropertyWizardFormRelay__Validators__Showings.Showing.Notes.useIsValid());
  var showFieldValidations = Core__Option.isSome(typProps.value) || Core__Option.isSome(startTimeProps.value) || Core__Option.isSome(endTimeProps.value) || Core__Option.isSome(dateProps.value);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs(CssGrid.Grid, {
                        children: [
                          JsxRuntime.jsxs(CssGrid.Cell, {
                                width: 12,
                                widthMd: 3,
                                children: [
                                  JsxRuntime.jsx(Form__Label.make, {
                                        labelText: "Date"
                                      }),
                                  JsxRuntime.jsx(ReactDatepicker.make, {
                                        placeholderText: "Showing date",
                                        onChange: (function (date) {
                                            dateProps.onChange(date);
                                          }),
                                        selected: dateProps.value,
                                        minDate: Caml_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)))
                                      }),
                                  showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                                          valid: dateProps.valid
                                        }) : null
                                ]
                              }),
                          JsxRuntime.jsxs(CssGrid.Cell, {
                                width: 6,
                                widthMd: 3,
                                children: [
                                  JsxRuntime.jsx(PropertyWizardFormRelay__Elements.TimePicker.make, {
                                        value: PropertyWizardRelayUtils.FormUtils.decodeTime(startTimeProps.value),
                                        onChange: (function (time) {
                                            startTimeProps.onChange(Core__Option.map(time, Types__Time.encode));
                                          }),
                                        label: "Start time",
                                        placeholder: "Start time",
                                        startTime: 9,
                                        isClearable: true,
                                        endTime: 21,
                                        hourlyIntervals: 2
                                      }),
                                  showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                                          valid: startTimeProps.valid
                                        }) : null
                                ]
                              }),
                          JsxRuntime.jsxs(CssGrid.Cell, {
                                width: 6,
                                widthMd: 3,
                                children: [
                                  JsxRuntime.jsx(PropertyWizardFormRelay__Elements.TimePicker.make, {
                                        value: PropertyWizardRelayUtils.FormUtils.decodeTime(endTimeProps.value),
                                        onChange: (function (time) {
                                            endTimeProps.onChange(Core__Option.map(time, Types__Time.encode));
                                          }),
                                        label: "End time",
                                        placeholder: "End time",
                                        startTime: 10,
                                        isClearable: true,
                                        endTime: 22,
                                        hourlyIntervals: 2
                                      }),
                                  showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                                          valid: endTimeProps.valid
                                        }) : null
                                ]
                              }),
                          JsxRuntime.jsxs(CssGrid.Cell, {
                                width: 12,
                                widthMd: 3,
                                children: [
                                  JsxRuntime.jsx(PropertyWizardRelay__Showings__Showing$ShowingTypeInputField, {
                                        value: typProps.value,
                                        onChange: (function (v) {
                                            typProps.onChange(v);
                                          })
                                      }),
                                  showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                                          valid: typProps.valid
                                        }) : null
                                ]
                              }),
                          JsxRuntime.jsx(CssGrid.Cell, {
                                width: 12,
                                children: Caml_option.some(JsxRuntime.jsx(Form__TextAreaField.make, {
                                          labelText: "Notes",
                                          optionalText: "optional",
                                          onChange: (function (e) {
                                              var value = e.target.value;
                                              notesProps.onChange(value);
                                            }),
                                          value: notesProps.value
                                        }))
                              }),
                          JsxRuntime.jsx(CssGrid.Cell, {
                                width: 12,
                                children: Caml_option.some(JsxRuntime.jsx(View__Jsx3.make, {
                                          justifyContent: "flexEnd",
                                          children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                                    onClick: (function (param) {
                                                        updateDraftProperty(function (localDraftProperty) {
                                                              var showings = localDraftProperty.showings.slice();
                                                              showings.splice(showingNum, 1);
                                                              var newrecord = Caml_obj.obj_dup(localDraftProperty);
                                                              newrecord.showings = showings;
                                                              return newrecord;
                                                            });
                                                      }),
                                                    children: "Remove showing"
                                                  }))
                                        }))
                              })
                        ]
                      }))
            });
}

var Components;

var FormSection;

var Validators;

var FormUtils;

var Form;

var Cell;

var Grid;

var Elements;

var make = PropertyWizardRelay__Showings__Showing;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Grid = Grid;
exports.Elements = Elements;
exports.ShowingTypeInputField = ShowingTypeInputField;
exports.ShowingFragment = ShowingFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* options Not a pure module */
